package music.jammers.shared.event.track.domain.model

import kotlinx.serialization.Serializable
import music.jammers.shared.event.domain.model.EventInstrument

@Serializable
data class AddEventTrack(
    val trackName: String,
    val artistName: String,
    val comment: String,
    val instruments: List<EventInstrument>,
)